<template>
    <!-- Icon picker -->
    <div class="modal fade" id="iconPicker" tabindex="-1" aria-labelledby="iconPickerModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable d-flex">
            <div class="modal-content m-auto">
                <div class="modal-header">
                    <h5 class="modal-title" id="iconPickerModal">Icônes</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form>
                        <span v-for="icon in icons" :key="icon">
                            <input type="radio" v-model="chosenIcon" class="sr-only" :id=icon :value=icon>
                            <label :for=icon class="icon-label p-1 m-1 rounded">
                                <img v-if="!missingIcons.includes(icon)" :src="`/img/cars/` + icon"
                                    @error="markAsMissing(icon)">
                            </label>
                        </span>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" v-on:click="updateIcon()"
                        :disabled="chosenIcon === null">Enregistrer</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaliseService from '@/services/balise.service.js'

export default {
    props: ['baliseToUpdate'],
    data() {
        return {
            icons: [],
            missingIcons: [],
            chosenIcon: null
        }
    },
    mounted() {
        fetch('/img/cars/icons.json')
            .then(res => res.json())
            .then(data => {
                this.icons = data
            })
    },
    methods: {
        updateIcon() {
            BaliseService.updateIcon(this.baliseToUpdate, this.chosenIcon)
                .then(() => {
                    this.$emit('icon-updated', this.chosenIcon);
                    this.$parent.refreshData();
                })
                .catch(e => {
                    console.log(e);
                });
        },
        markAsMissing(name) {
            if (!this.missingIcons.includes(name)) {
                this.missingIcons.push(name)
            }
        }
    }
}
</script>

<style>
.modal-open {
    padding: 0 !important;
}

.modal.fade.show {
    z-index: 2000;
}

label.icon-label {
    cursor: pointer;
    transition: all .2s ease-in-out;
}

label.icon-label:hover {
    transform: scale(1.1);
}

input[type="radio"]:checked+label.icon-label {
    background-color: #adb5bd;
    box-shadow: 0 1rem 2rem rgba(0, 0, 0, .175);
    transform: scale(1.1);
}
</style>